import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { mapState } from 'vuex';
import topTitle from '@/components/title.vue';
import infoForm from '../components/infoForm.vue';
import planExplanation from '../components/planExplanation.vue';
import { insuranceResource, mainPlanResource } from '@/views/insurance/insuranceManage/request';
import { planRelateData } from '@/views/policy/customerManage/request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { policyBatchCheckField } from '../request2';
export default {
  components: {
    topTitle,
    infoForm,
    planExplanation
  },
  props: ['id', 'visible', 'showData', 'editIndex', 'templateRenderList', 'isFail'],
  watch: {
    visible(newV) {
      if (newV) {
        this.getProduction();
      }
    },
    showData: {
      handler(newV) {
        this.newShowData = newV;
      },
      deep: true
    },
    templateRenderList: {
      handler(newV) {
        this.getProduction();
        // this.myTemplateRenderList = newV;
      },
      deep: true
    }
  },
  data() {
    const h = this.$createElement;
    return {
      indicator: h("a-icon", {
        "attrs": {
          "type": "loading",
          "spin": true
        },
        "style": "font-size: 24px"
      }),
      form: {
        attachValue: [],
        areaCodeValue: []
      },
      columns: [{
        slots: {
          title: '产品名称'
        },
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        className: 'td-bg'
      }, {
        slots: {
          title: '保障额度'
        },
        dataIndex: 'amount',
        key: 'amount',
        scopedSlots: {
          customRender: 'amount'
        },
        className: 'td-bg'
      }],
      continueState: false,
      explanationVisible: false,
      insuranceList: [],
      planList: [],
      tableData: [],
      hasAttachInfo: false,
      isAreaPrice: false,
      myTemplateRenderList: {},
      template: [],
      formResult: false,
      insureForm: [],
      discountInfo: [],
      checkFieldData: [],
      spinning: true,
      newShowData: recursionCopy(this.showData)
    };
  },
  computed: {
    topRules() {
      return {
        insuranceId: [{
          required: true,
          message: this.$t('请选择') + this.$t('产品名称'),
          trigger: 'change'
        }],
        planId: [{
          required: true,
          message: this.$t('请选择') + this.$t('保险方案'),
          trigger: 'change'
        }],
        areaCodeValue: [{
          required: true,
          message: this.$t('请选择') + this.$t('地区'),
          trigger: 'change'
        }],
        add: {
          required: false,
          validator: this.addValidor,
          trigger: 'change'
        }
      };
    },
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  methods: {
    addValidor(rule, value, callback) {
      if (this.form.attachValue.length) {
        if (this.tableData.findIndex(item => {
          var _item$attachPlan;
          return !((_item$attachPlan = item.attachPlan) !== null && _item$attachPlan !== void 0 && _item$attachPlan.length);
        }) > -1) {
          return callback(new Error('附加险保障额度不能为空'));
        }
      }
      callback();
    },
    async getProduction() {
      this.resetInfo();
      this.insureForm = [];
      this.spinning = true;
      this.myTemplateRenderList = recursionCopy(this.templateRenderList);
      this.insuranceList = await insuranceResource({
        position: 'batchPolicy'
      });
      this.form.insuranceId = this.myTemplateRenderList.customerInsuranceId;
      await this.dataProcessing();
    },
    async dataProcessing() {
      var _this$myTemplateRende;
      let production = (_this$myTemplateRende = this.myTemplateRenderList) === null || _this$myTemplateRende === void 0 || (_this$myTemplateRende = _this$myTemplateRende.insuredInfo) === null || _this$myTemplateRende === void 0 || (_this$myTemplateRende = _this$myTemplateRende[this.editIndex]) === null || _this$myTemplateRende === void 0 ? void 0 : _this$myTemplateRende.commonInfo;
      if (production) {
        var _this$planList;
        await this.changeInsuranceId();
        this.form.planId = (_this$planList = this.planList) === null || _this$planList === void 0 || (_this$planList = _this$planList.find(i => i.mark == production.insurancePlanCode)) === null || _this$planList === void 0 ? void 0 : _this$planList.id;
        if (this.form.planId && this.form.insuranceId) {
          await this.changePlan();
          // 地区赋值
          if (this.rearOptions.length && production.areaCode) {
            this.rearOptions.map(item => {
              var _item$children;
              (_item$children = item.children) === null || _item$children === void 0 || _item$children.map(item1 => {
                if (production.areaCode == item1.value) {
                  this.form.areaCodeValue = [item.value, item1.value];
                }
              });
            });
          } else {
            this.form.areaCodeValue = [];
          }
          // 附加险赋值
          if (this.attachOptions.length) {
            this.attachOptions.forEach(item => {
              var _item$attachPlan2;
              (_item$attachPlan2 = item.attachPlan) === null || _item$attachPlan2 === void 0 || _item$attachPlan2.forEach(item1 => {
                if (production.insuranceAttachPlanCode && production.insuranceAttachPlanCode.includes(item1.mark)) {
                  if (!this.form.attachValue.includes(item.attachId)) {
                    this.form.attachValue.push(item.attachId);
                  }
                  this.changeAdditional();
                  this.amountSelect(item1.id, this.tableData.find(i => i.name == item.name));
                }
              });
            });
          }
        }
        this.spinning = false;
      }
    },
    // 获取更新form
    onUpdateForm(value) {
      this.insureForm = value;
    },
    async changeInsuranceId() {
      if (this.form.insuranceId) {
        var _this$insuranceList$f;
        this.form.applicationId = this.insuranceList.find(i => i.insuranceCustomerId === this.form.insuranceId).applicationId;
        const res = await mainPlanResource({
          insuranceId: (_this$insuranceList$f = this.insuranceList.find(i => i.insuranceCustomerId === this.form.insuranceId)) === null || _this$insuranceList$f === void 0 ? void 0 : _this$insuranceList$f.id
        });
        this.planList = res.items.map(item => {
          item.rightsCont = JSON.parse(item.rights);
          return item;
        });
      }
    },
    async changePlan(key) {
      let arr = this.planList.filter(item => item.id === this.form.planId);
      if (key === true) {
        this.resetInfo();
      }
      if (arr.length) {
        let selectPlanInfo = arr[0];
        this.$set(this.form, 'wait', selectPlanInfo.duration);
        //是否是区域保费
        this.isAreaPrice = selectPlanInfo.priceType === 'AREA_PRICE' ? true : false;
        let defaultValue = selectPlanInfo.priceType === 'AREA_PRICE' ? undefined : selectPlanInfo.price;
        this.$set(this.form, 'premiumPrice', defaultValue);
        //区域保费得下拉选择数据
        this.priceMap = {};
        const formatShowArea = (data, price) => {
          const result = data.map(item => {
            let obj = {};
            if (item.city && item.city.length) {
              obj.children = formatShowArea(item.city, item.price);
            }
            this.priceMap[item.code] = price || item.price;
            obj.value = item.code;
            obj.label = item.name;
            obj.areaIndex = item.areaIndex;
            return obj;
          });
          return result;
        };
        let allShowArea = selectPlanInfo.allShowArea ? JSON.parse(selectPlanInfo.allShowArea) : [];
        this.rearOptions = formatShowArea(allShowArea);
        //附加险信息
        this.attachOptions = selectPlanInfo.attachInfo && JSON.parse(selectPlanInfo.attachInfo);
        if (this.attachOptions && this.attachOptions.length) {
          this.hasAttachInfo = true; //控制是否展示附加险信息
          this.attachOptions.forEach(item => {
            if (item.buyLimit === 1) {
              item.disabled = true;
              item.allowClear = false;
              if (!this.form.attachValue.includes(item.attachId)) this.form.attachValue.push(item.attachId);
            }
          });
        }
        this.changeAdditional();
      }
      if (this.visible) {
        await this.getPlanRelateData();
      }
    },
    amountSelect(value, record) {
      let attachPLan = record.attachPlan && Array.isArray(record.attachPlan) && record.attachPlan.filter(item => item.id === value);
      if (attachPLan.length) {
        this.$set(record, 'price', attachPLan[0].price);
        this.$set(record, 'attachPlanId', value);
        this.$set(record, 'mark', attachPLan[0].mark);
        this.tableData = [...this.tableData];
      }
    },
    changeAdditional(e) {
      this.tableData = [];
      this.form.attachValue && this.form.attachValue.forEach(value => {
        var _this$attachOptions;
        if ((_this$attachOptions = this.attachOptions) !== null && _this$attachOptions !== void 0 && _this$attachOptions.length) {
          var _this$attachOptions2;
          let selectItem = (_this$attachOptions2 = this.attachOptions) === null || _this$attachOptions2 === void 0 ? void 0 : _this$attachOptions2.filter(item => item.attachId === value);
          if (selectItem.length) {
            let item = selectItem[0];
            //默认选中第一个方案
            if (!item.attachPlan) {
              //保障额度一个都没有的情况
              item.attachPlanId = '-';
              item.price = '-';
              item.amount = '-';
            } else {
              var _item$attachPlan3, _item$attachPlan4, _item$attachPlan5;
              item.attachPlanId = item.attachPlanId || ((_item$attachPlan3 = item.attachPlan) === null || _item$attachPlan3 === void 0 || (_item$attachPlan3 = _item$attachPlan3[0]) === null || _item$attachPlan3 === void 0 ? void 0 : _item$attachPlan3.id) || '-';
              item.price = item.price || ((_item$attachPlan4 = item.attachPlan) === null || _item$attachPlan4 === void 0 || (_item$attachPlan4 = _item$attachPlan4[0]) === null || _item$attachPlan4 === void 0 ? void 0 : _item$attachPlan4.price) || '-';
              item.mark = item.mark || ((_item$attachPlan5 = item.attachPlan) === null || _item$attachPlan5 === void 0 || (_item$attachPlan5 = _item$attachPlan5[0]) === null || _item$attachPlan5 === void 0 ? void 0 : _item$attachPlan5.mark) || '-';
              if (item.attachPlan.length === 1) {
                //只有一个方案的直接保障额度使用文本展示
                item.amount = item.amount || item.attachPlan[0].amount;
              }
            }
            this.tableData.push(item);
          }
        }
      });
    },
    onSave() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          this.checkFieldData = [];
          this.formResult = true;
        }
      });
    },
    validate(val) {
      this.formResult = false;
      if (val) {
        this.toSaveData();
      }
    },
    async toSaveData() {
      var _this$insuranceList$f2;
      let params = {
        insuranceId: (_this$insuranceList$f2 = this.insuranceList.find(i => i.insuranceCustomerId === this.form.insuranceId)) === null || _this$insuranceList$f2 === void 0 ? void 0 : _this$insuranceList$f2.id,
        insuredInfo: this.getInsuredInfo(1)
      };
      const res = await policyBatchCheckField(params);
      let passRes = res.insuredInfo.findIndex(i => i.isCheck);
      if (passRes > -1) {
        // 传回有错误信息数据
        this.checkFieldData = res.insuredInfo.map(item => {
          if (item.insured) {
            item.insured = item.insured[0];
          }
          return item;
        });
      } else {
        this.checkFieldData = [];
        this.myTemplateRenderList.insuredInfo[this.editIndex] = this.getInsuredInfo(2).map(item => {
          if (item.insured) {
            item.insured = item.insured[0];
          }
          return item;
        })[0];
        this.newShowData = this.updateShowTableData(this.newShowData);
        this.$emit('updateTemplate', {
          templateRenderList: this.myTemplateRenderList,
          showData: this.newShowData
        });
        this.$message.destroy();
        this.$message.success(this.$t('保存成功'));
        this.close();
      }
    },
    updateShowTableData(showData) {
      if (this.isFail) {
        var _this$planList$find;
        // 方案名称赋值
        let planName = (_this$planList$find = this.planList.find(i => i.id == this.form.planId)) === null || _this$planList$find === void 0 ? void 0 : _this$planList$find.name;
        // showData.forEach(item => {
        //   item.planName = planName;
        // });
        showData[this.editIndex].planName = planName;
        // 前三被保人信息赋值
        let insured = this.myTemplateRenderList.insuredInfo[this.editIndex].insured;
        insured.forEach(item => {
          let find = Object.entries(showData[this.editIndex]).find(i => i[0].includes(item.code));
          if (find) {
            showData[this.editIndex][find[0]] = item.valData1 ? item.valData1 : item.valData;
          }
        });
      } else {
        var _this$planList$find2;
        // 方案名称赋值
        let planName = (_this$planList$find2 = this.planList.find(i => i.id == this.form.planId)) === null || _this$planList$find2 === void 0 ? void 0 : _this$planList$find2.name;
        showData.forEach((item, i) => {
          if (i === this.editIndex) {
            if (item['方案名称']) {
              item['方案名称'] = planName;
            } else if (item['*方案名称']) {
              item['*方案名称'] = planName;
            } else {
              item.planName = planName;
            }
          }
        });
        // 前三被保人信息赋值
        let insured = this.myTemplateRenderList.insuredInfo[this.editIndex].insured;
        insured.forEach(item => {
          let find = Object.entries(showData[this.editIndex]).find(i => i[0].includes(item.name));
          if (find) {
            showData[this.editIndex][find[0]] = item.valData1 ? item.valData1 : item.valData;
          }
        });
      }
      showData[this.editIndex].errorMessage = [];
      return showData;
    },
    /**
     * @description 生成insuredInfo参数
     * @param {*} key 1 验证接口 2 保存接口
     */
    getInsuredInfo(key) {
      let insuranceInfo = this.insuranceList.find(i => i.insuranceCustomerId === this.form.insuranceId);
      let planInfo = this.planList.find(i => i.id == this.form.planId);
      let insuredInfo = [];
      let insuranceAttachPlanCode = this.tableData.map(i => i.mark).join(',');
      let attachInfo = this.tableData.map(item => {
        item.attachPlan = item.attachPlan.filter(i => insuranceAttachPlanCode.includes(i.mark));
        return item;
      });
      this.insureForm.forEach(item => {
        let obj = {};
        item.forEach(item1 => {
          obj[item1.code] = [];
          item1.item.forEach(item2 => {
            let obj1 = {};
            obj1.code = item2.code;
            obj1.name = item2.name;
            obj1.display = item2.display;
            obj1.id = item2.id;
            obj1.type = item2.type;
            obj1.valData = item2.inputKey;
            if (item2.value) {
              var _item2$value$find;
              obj1.valData1 = ((_item2$value$find = item2.value.find(i => i.key == item2.inputKey)) === null || _item2$value$find === void 0 ? void 0 : _item2$value$find.value) || '';
            }
            if (item2.display == 'dropDownBox(region)') {
              obj1.defaultValue = item2.inputKey;
              obj1.valData = item2.inputValue;
            }
            obj[item1.code].push(obj1);
          });
          let areaName = '';
          let areaPrice = '';
          let areaIndex;
          if (planInfo.allShowArea && JSON.parse(planInfo.allShowArea)) {
            JSON.parse(planInfo.allShowArea).forEach(item => {
              if (this.form.areaCodeValue.includes(item.code)) {
                var _item$city$find, _item$city$find2, _item$city$find3;
                areaName = item.name + ' ' + ((_item$city$find = item.city.find(i => this.form.areaCodeValue.includes(i.code))) === null || _item$city$find === void 0 ? void 0 : _item$city$find.name);
                areaPrice = (_item$city$find2 = item.city.find(i => this.form.areaCodeValue.includes(i.code))) === null || _item$city$find2 === void 0 ? void 0 : _item$city$find2.price;
                areaIndex = (_item$city$find3 = item.city.find(i => this.form.areaCodeValue.includes(i.code))) === null || _item$city$find3 === void 0 ? void 0 : _item$city$find3.areaIndex;
              }
            });
          }
          if (key == 2 && item1.code == 'commonInfo' || key == 2 && item.findIndex(i => i.code == 'commonInfo') == -1) {
            if (item1.code == 'commonInfo') {
              var _this$form$areaCodeVa, _this$discountInfo$fi, _this$discountInfo$, _this$discountInfo$fi2, _this$discountInfo$2, _this$discountInfo$fi3, _this$discountInfo$3;
              obj[item1.code] = {
                commonTemplate: obj[item1.code],
                // operateDate:
                insuranceCustomerCode: insuranceInfo.insuranceCustomerCode,
                insurancePlanCode: planInfo.mark,
                insuranceName: insuranceInfo.customerInsuranceName,
                insurancePlanName: planInfo.name,
                insuranceAttachPlanCode,
                price: planInfo.price,
                insurancePlanAmount: planInfo.amount,
                areaCode: ((_this$form$areaCodeVa = this.form.areaCodeValue) === null || _this$form$areaCodeVa === void 0 ? void 0 : _this$form$areaCodeVa[1]) || '',
                areaName,
                areaPrice: areaPrice || '',
                discountMode: areaName ? (_this$discountInfo$fi = this.discountInfo.find(i => i.areaIndex === areaIndex)) === null || _this$discountInfo$fi === void 0 ? void 0 : _this$discountInfo$fi.discountMode : (_this$discountInfo$ = this.discountInfo[0]) === null || _this$discountInfo$ === void 0 ? void 0 : _this$discountInfo$.discountMode,
                discountRatio: areaName ? (_this$discountInfo$fi2 = this.discountInfo.find(i => i.areaIndex === areaIndex)) === null || _this$discountInfo$fi2 === void 0 ? void 0 : _this$discountInfo$fi2.discountRatio : (_this$discountInfo$2 = this.discountInfo[0]) === null || _this$discountInfo$2 === void 0 ? void 0 : _this$discountInfo$2.discountRatio,
                discountAmount: areaName ? (_this$discountInfo$fi3 = this.discountInfo.find(i => i.areaIndex === areaIndex)) === null || _this$discountInfo$fi3 === void 0 ? void 0 : _this$discountInfo$fi3.discountAmount : (_this$discountInfo$3 = this.discountInfo[0]) === null || _this$discountInfo$3 === void 0 ? void 0 : _this$discountInfo$3.discountAmount,
                attachInfo,
                insureCount: 1,
                policyId: this.isFail ? this.showData[this.editIndex].id : ''
              };
            } else {
              var _this$form$areaCodeVa2, _this$discountInfo$fi4, _this$discountInfo$4, _this$discountInfo$fi5, _this$discountInfo$5, _this$discountInfo$fi6, _this$discountInfo$6;
              obj['commonInfo'] = {
                insuranceCustomerCode: insuranceInfo.insuranceCustomerCode,
                insurancePlanCode: planInfo.mark,
                insuranceName: insuranceInfo.customerInsuranceName,
                insurancePlanName: planInfo.name,
                insuranceAttachPlanCode,
                price: planInfo.price,
                insurancePlanAmount: planInfo.amount,
                areaCode: ((_this$form$areaCodeVa2 = this.form.areaCodeValue) === null || _this$form$areaCodeVa2 === void 0 ? void 0 : _this$form$areaCodeVa2[1]) || '',
                areaName,
                areaPrice: areaPrice || '',
                discountMode: areaName ? (_this$discountInfo$fi4 = this.discountInfo.find(i => i.areaIndex === areaIndex)) === null || _this$discountInfo$fi4 === void 0 ? void 0 : _this$discountInfo$fi4.discountMode : (_this$discountInfo$4 = this.discountInfo[0]) === null || _this$discountInfo$4 === void 0 ? void 0 : _this$discountInfo$4.discountMode,
                discountRatio: areaName ? (_this$discountInfo$fi5 = this.discountInfo.find(i => i.areaIndex === areaIndex)) === null || _this$discountInfo$fi5 === void 0 ? void 0 : _this$discountInfo$fi5.discountRatio : (_this$discountInfo$5 = this.discountInfo[0]) === null || _this$discountInfo$5 === void 0 ? void 0 : _this$discountInfo$5.discountRatio,
                discountAmount: areaName ? (_this$discountInfo$fi6 = this.discountInfo.find(i => i.areaIndex === areaIndex)) === null || _this$discountInfo$fi6 === void 0 ? void 0 : _this$discountInfo$fi6.discountAmount : (_this$discountInfo$6 = this.discountInfo[0]) === null || _this$discountInfo$6 === void 0 ? void 0 : _this$discountInfo$6.discountAmount,
                attachInfo,
                insureCount: 1,
                policyId: this.isFail ? this.showData[this.editIndex].id : ''
              };
            }
          }
        });
        if (obj.insured) {
          obj.insured = [obj.insured];
        }
        insuredInfo.push(obj);
      });
      return insuredInfo;
    },
    areaChange(value, selectOption) {
      let key = value[value.length - 1];
      this.$set(this.form, 'areaCode', key);
    },
    async getPlanRelateData() {
      var _this$insuranceList$f3;
      //根据保险方案获取干系人的相关信息以及折扣的信息
      if (!this.form.planId) {
        return;
      }
      const {
        customerId,
        structureId
      } = this.accountInfo;
      let params = {
        customerId,
        structureId,
        insuranceId: (_this$insuranceList$f3 = this.insuranceList.find(i => i.insuranceCustomerId === this.form.insuranceId)) === null || _this$insuranceList$f3 === void 0 ? void 0 : _this$insuranceList$f3.id,
        insurancePlanId: this.form.planId,
        applicationId: this.form.applicationId
      };
      this.applicantTypeTemOption = [];
      this.insuredTemplate = [];
      const res = await planRelateData(params);
      if (res) {
        this.discountInfo = res.discountInfo;
        let templateItem = recursionCopy(this.myTemplateRenderList.insuredInfo[this.editIndex]);
        Array.isArray(res.templateRenderList) && res.templateRenderList.forEach((item, index) => {
          if (item.code === 'applicant') {
            res.templateRenderList[index].item[0].inputKey = templateItem.applicant.find(i => i.name == '投保类型').valData || 'NATURAL_PERSON';
            if (item.item[0].inputKey === 'COMPANY') {
              res.templateRenderList[index].item.push(...item.company);
              // applicantInfo = item.company;
            }
            if (item.item[0].inputKey === 'NATURAL_PERSON') {
              res.templateRenderList[index].item.push(...item.personal);
              // applicantInfo = item.personal;
            }
            if (item.item[0].code === 'applicantType') {
              res.templateRenderList[index].item[0].display = 'radio';
            }
          }
          item.item.forEach((item1, index1) => {
            if (item1.display == 'dropDownBox(region)') {
              res.templateRenderList[index].item[index1].inputKey = [];
            }
          });
        });
        let templateList = res.templateRenderList.map(item => {
          let _itemData;
          if (item.code != 'commonInfo') {
            _itemData = templateItem[item.code] || [];
          } else {
            var _templateItem$item$co;
            if ((_templateItem$item$co = templateItem[item.code]) !== null && _templateItem$item$co !== void 0 && (_templateItem$item$co = _templateItem$item$co.commonTemplate) !== null && _templateItem$item$co !== void 0 && _templateItem$item$co.length) {
              _itemData = templateItem[item.code].commonTemplate;
            } else {
              _itemData = [];
            }
          }
          item.item = item.item.map(item1 => {
            let isSame = _itemData.findIndex(i => i.code == item1.code);
            if (isSame > -1) {
              item1.inputKey = _itemData[isSame].valData;
            }
            return item1;
          });
          return item;
        });
        this.template = templateList;
      }
    },
    resetInfo() {
      this.hasAttachInfo = false; //清空附加险信息
      this.isAreaPrice = false; //区域保费信息清空
      this.rearOptions = []; //区域保费信息清空
      this.applicantList = []; //清空投保人信息
      this.tableData = []; //清空已选择的附加险方案信息
      this.form.attachValue = []; //清空已选择的附加险
      this.form.areaCodeValue = [];
      this.form.areaCode = ''; //区域保费的区域的code
      this.form.attachValue = [];
    },
    close() {
      this.resetInfo();
      this.form.insuranceId = undefined;
      this.form.insuranceName = undefined;
      this.form.applicationId = undefined;
      this.form.planId = undefined;
      this.template = [];
      this.myTemplateRenderList = [];
      this.$emit('cancel');
      this.spinning = false;
    }
  }
};